module.exports = __webpack_public_path__ + "static/media/event.885dcdc7.svg";